import React from 'react';
import styles from './step.module.css';

const Step = (props) => {
  return (
    <p className={styles.step_text}>Step {props.currentStep} of 17</p>
  );
}

export { Step };